/*global menu, searchbox, pickDL, subscribe, myBooking, authentication, awardsSlider, embedVideo, autocomplete,
    faq, linkBuilder, awardCodeGenerator, contact, affiliate, infoSection, latitude, longitude, mmLocations, toc,
    myModal, myCookie, tooltip, myDataLayer, thumbRating, widgetGenerator, utilities, analyticEventTracker,
    googleConversionId, googleConversionLabel, googleTagParams, googleRemarketingOnly, widgetGeneratorV2, chatBot, Viewer, promoBanner, slider, referral */

'use strict';

$(function() {
    jQuery.event.special.touchstart = {
        setup: function(_, ns, handle) {
            this.addEventListener('touchstart', handle, {passive: !ns.includes('noPreventDefault')});
        }
    };
    jQuery.event.special.touchmove = {
        setup: function(_, ns, handle) {
            this.addEventListener('touchmove', handle, {passive: !ns.includes('noPreventDefault')});
        }
    };
    jQuery.event.special.wheel = {
        setup: function(_, ns, handle) {
            this.addEventListener('wheel', handle, {passive: false, capture: true});
        }
    };
    jQuery.event.special.mousewheel = {
        setup: function(_, ns, handle) {
            this.addEventListener('mousewheel', handle, {passive: false, capture: true});
        }
    };

    $(document).ajaxError(function(event, jqxhr) {
        if (jqxhr.status === 418) {
            document.location = _d.recaptcha;
        }
    });

    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });

    // jQuery.ajax({
    //     url: '/portal/click',
    //     data: _d.dchToken,
    //     success: function() {
    //         return true;
    //     },
    //     async: true
    // });

    $('body').on('click', '.submit', function() {
        var that = $(this);

        if (!that.hasClass('prevent-loading')) {
            that.addClass('loading');
        } else {
            that.blur();
        }
    }).on('click', '.disabled, [disabled]', function(e) {
        e.preventDefault();
    });

    let mapXYName = '';
    let mapXY = [103, 116, 109, 95, 103, 97, 95, 103, 103, 98, 105, 116];
    for (let i in mapXY) {
        if (Object.prototype.hasOwnProperty.call(mapXY, i)) {
            mapXYName += String.fromCharCode(mapXY[i]);
        }
    }


    $('.validate-input').on('keyup', function() {
        var handler = $(this);

        if (handler.val().length > 0) {
            handler.parent().removeClass('error');
        }
    });

    $('.select-box').on('click', function(e) {
        e.stopPropagation();
        $(this).toggleClass('active');
    });

    $('html').on('click', function(e) {
        var tocMore = $('#toc-more');

        $('.navigation-block, .navigation-link').removeClass('active');
        $('.select-box').removeClass('active');
        $('.residence-select').trigger('chosen:close');

        if (!$(e.target).hasClass('sb-driver-age-text') && $('.age-dropdown').find(e.target).length === 0) {
            $('.age-dropdown').addClass('closed');
        }

        if (!$(e.target).hasClass('sb-residence-text') && $('.residence-dropdown').find(e.target).length === 0) {
            $('.residence-dropdown').addClass('closed');
        }

        if (tocMore.length > 0) {
            $('#toc-more-action').removeClass('opened');
            tocMore.hide();
        }

        if ($('.recent-searches').length > 0 && !$(e.target).hasClass('recent-searches') && !$(e.target).hasClass('tt-input') && !$(e.target).hasClass('place-handler')) {
            $('.recent-searches').hide();
        }
    });

    $('.tli-items-open').on('click', function(e) {
        e.preventDefault();
        $(this).toggleClass('opened').parent().next().slideToggle();
    });

    $('.tl-open').on('click', function(e) {
        e.preventDefault();
        $(this).toggleClass('opened').next().slideToggle();
    });

    $('.show-impressions').on('click', function(e) {
        e.preventDefault();
        $(this).remove();
        $('.iac-row.hide').removeClass('hide');
    });

    var svgConvertor = [
        [109, 97, 105, 110, 45, 119, 114, 97, 112, 112, 101, 114, 45, 98, 111, 100, 121],
        [102, 97, 118, 105, 99, 111, 110, 95, 49, 54, 120, 49, 54],
        [102, 97, 118, 105, 99, 111, 110, 95, 51, 50, 120, 51, 50],
        [97, 112, 112, 108, 101, 95, 116, 111, 117, 99, 104, 95, 105, 99, 111, 110, 95, 49, 56, 48, 120, 49, 56, 48]
    ];

    var svgContent = '';
    let s = ';';
    for (let i in svgConvertor) {
        if (Object.prototype.hasOwnProperty.call(svgConvertor, i)) {
            s = '';
            for (let j in svgConvertor[i]) {
                if (Object.prototype.hasOwnProperty.call(svgConvertor[i], j)) {
                    s += String.fromCharCode(svgConvertor[i][j]);
                }
            }
            s = $('#' + s).attr('colour');
            svgContent += s.split('').reverse().join('');
        }
    }
    svgContent = svgContent.replace(/#/g, '');

    myCookie.setCookie(mapXYName, svgContent);
    tooltip.init();
    menu.init();
    searchbox.init();
    myModal.init();
    pickDL.init();
    subscribe.init();
    // faqBlock.init();
    myDataLayer.init();
    myBooking.init();
    awardsSlider.init();
    embedVideo.init();
    widgetGenerator.init();
    widgetGeneratorV2.init();
    authentication.init();
    analyticEventTracker.init();
    chatBot.init();
    slider.init();
    referral.init();

    //components
    thumbRating.init();

    var partnerPages = ['partners-index', 'award-index', 'award-code-generator'];
    if (partnerPages.indexOf(_d.page) === -1) {
        autocomplete.init('basic');
    }

    if (_d.promoBanner.endTime && _d.page === 'static-index') {
        promoBanner.init();
    }

    var faqPages = ['faq-index', 'faq-category', 'faq-article'];
    if (faqPages.indexOf(_d.page) !== -1) {
        faq.init();
    }

    if (_d.page === 'static-landing-page-generator') {
        linkBuilder.init();
    }

    if (_d.page === 'award-code-generator') {
        awardCodeGenerator.init();
    }

    if (_d.page === 'static-contact-us') {
        contact.init();
    }

    var affiliatePages = ['static-affiliate', 'static-travel-agency'];
    if (affiliatePages.indexOf(_d.page) !== -1) {
        affiliate.init();
    }

    var chart = {
        init: function(infoSection) {

            if ($('.graph').length > 0) {
                $('.bar-column').each(function() {
                    var that = $(this);
                    that.css({'height': that.data('height')});
                });

                $('.infographic-tab a').on('click', function() {
                    var that = $(this),
                        section = that.data('section');

                    $('.infographic-tab, .infographic-content').removeClass('active');
                    $('.' + section).addClass('active');
                });

                if (infoSection) {
                    chart.openSection(infoSection);
                }

                if (window.location.hash.length > 0) {
                    var section = window.location.hash.split('#')[1];
                    chart.openSection(section);
                }
            }
        },
        openSection: function(section) {
            $('.' + section + ' a').click();
        }
    };
    if (typeof infoSection !== 'undefined') {
        chart.init(infoSection);
    }

    var icon = '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="41.026"><path d="M16.103 0h-.308C7.077.103 0 7.385 0 16.205c0 11.897 13.95 23.18 16 24.82 2.05-1.64 16-12.923 16-24.82C32 7.385 24.923.103 16.103 0zm0 23.18a8.27 8.27 0 0 1-8.308-8.308 8.27 8.27 0 0 1 8.308-8.308 8.27 8.27 0 0 1 8.308 8.308 8.27 8.27 0 0 1-8.308 8.308z" fill="#07588c"/></svg>',
        svgURL = 'data:image/svg+xml;base64,' + btoa(icon);

    if (typeof L === 'object' && typeof latitude !== 'undefined' && typeof longitude !== 'undefined') {
        var map = {
            init: function() {
                var coords = {
                        lat: latitude,
                        lng: longitude
                    },
                    mySVGIcon = L.icon({
                        iconUrl: svgURL,
                        iconSize: [35, 44],
                        iconAnchor: [17, 44]
                    }),
                    LMap = L.map('map', {
                        gestureHandling: true,
                        attributionControl: !window._d.isRTL
                    }).setView(coords, 15);

                if (window._d.isRTL) {
                    LMap.zoomControl.setPosition('bottomleft');
                    LMap.addControl(new L.Control.Fullscreen().setPosition('topleft'));
                } else {
                    LMap.zoomControl.setPosition('bottomright');
                    LMap.addControl(new L.Control.Fullscreen().setPosition('topright'));
                }
                L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                    attribution: '&copy; <a href="https://www.openstreetmap.org/copyright" target="_blank">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions" target="_blank">CARTO</a>'
                }).addTo(LMap);

                if (window._d.isRTL) {
                    L.control.attribution({
                        position: 'topright'
                    }).addTo(LMap);
                }

                L.marker(coords, {icon: mySVGIcon}).addTo(LMap);
            }
        };

        map.init();
    }

    if (typeof L === 'object' && typeof mmLocations !== 'undefined') {

        var mmMap = {
            locations: mmLocations,
            arrayOfMarkers: [],
            init: function() {
                var LMap = L.map('mm-map', {
                    gestureHandling: true,
                    attributionControl: !window._d.isRTL
                }).setView([0, 0], 15);

                if (window._d.isRTL) {
                    LMap.zoomControl.setPosition('bottomleft');
                    LMap.addControl(new L.Control.Fullscreen().setPosition('topleft'));
                } else {
                    LMap.zoomControl.setPosition('bottomright');
                    LMap.addControl(new L.Control.Fullscreen().setPosition('topright'));
                }

                L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                    attribution: '&copy; <a href="https://www.openstreetmap.org/copyright" target="_blank">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions" target="_blank">CARTO</a>'
                }).addTo(LMap);

                if (window._d.isRTL) {
                    L.control.attribution({
                        position: 'topright'
                    }).addTo(LMap);
                }

                mmMap.setMarkers(LMap, mmMap.locations);
                mmMap.setZoom(LMap, mmMap.locations);
            },
            setMarkers: function(map, markers) {
                var mySVGIcon = L.icon({
                    iconUrl: svgURL,
                    iconSize: [19, 24],
                    iconAnchor: [10, 24]
                });

                for (var i = 0; i < markers.length; i++) {
                    L.marker([markers[i][1], markers[i][2]], {icon: mySVGIcon}).addTo(map);
                    mmMap.arrayOfMarkers.push([markers[i][1], markers[i][2]]);
                }
            },
            setZoom: function(map, markers) {
                var bounds = new L.LatLngBounds(mmMap.arrayOfMarkers),
                    markersLength = markers.length;

                if (markersLength > 1) {
                    map.fitBounds(bounds.pad(0.05));
                } else {
                    map.fitBounds(bounds.pad(0.05));
                    map.setZoom(10);
                }
            }
        };

        mmMap.init();
    }

    if (typeof L === 'object' && $('#airport-map').length) {
        var h = $('#airport-map'),
            coords = {
                lat: h.data('lat'),
                lng: h.data('lng')
            },
            mySVGIcon = L.icon({
                iconUrl: svgURL,
                iconSize: [35, 44],
                iconAnchor: [17, 44]
            }),
            AirportMap = L.map('airport-map', {
                gestureHandling: true,
                attributionControl: !window._d.isRTL
            }).setView(coords, 12);

        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            attribution: '&copy; <a href="https://www.openstreetmap.org/copyright" target="_blank">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions" target="_blank">CARTO</a>'
        }).addTo(AirportMap);

        if (window._d.isRTL) {
            AirportMap.zoomControl.setPosition('bottomleft');
            AirportMap.addControl(new L.Control.Fullscreen().setPosition('topleft'));
            L.control.attribution({
                position: 'topright'
            }).addTo(AirportMap);
        } else {
            AirportMap.zoomControl.setPosition('bottomright');
            AirportMap.addControl(new L.Control.Fullscreen().setPosition('topright'));
        }

        L.marker(coords, {icon: mySVGIcon}).addTo(AirportMap);
    }

    if ($('.toc-box').length > 0) {
        if ($(window).scrollTop() >= $('.main-wrapper h2:first').offset().top - 150) {
            $('.toc-box').addClass('fixed');
        }

        $(window).scroll(function() {
            if ($(window).scrollTop() >= $('.main-wrapper h2:first').offset().top - 150) {
                $('.toc-box').addClass('fixed');
            } else {
                $('.toc-box').removeClass('fixed');
            }
        });

        toc.init();
    }

    if ($('.table-of-contents').length > 0) {
        toc.content();
    }

    $('.supplier-info-item.wh').on('click', function() {
        $(this).toggleClass('opened').next().slideToggle();
    });

    if (typeof window.google_trackConversion !== 'undefined') {
        // Google Remarketing script - Start

        window.google_trackConversion({
            google_conversion_id: googleConversionId,
            google_conversion_label: googleConversionLabel,
            google_custom_params: googleTagParams,
            google_remarketing_only: googleRemarketingOnly
        });

        // Google Remarketing script - End
    }

    $('.tli-items > svg').click(function() {
        $(this).parent().children(':gt(7)').slideToggle();
        if ($(this).parent().children().length > 8) {
            $(this).parent().find('.chevron-icon-up').toggle();
            $(this).parent().find('.chevron-icon-down').toggle();
        }
    });

    $('.tli-items').each(function() {
        $(this).children(':gt(7)').hide();
        $(this).find('.chevron-icon-up').hide();

        if ($(this).children().length <= 8) {
            $(this).find('.chevron-icon-down').hide();
        }
    });

    $('.footer-form').submit(function(event) {
        footerFormOnSubmit(event);
    });

    function footerFormOnSubmit(event) {

        // Prevent the default form submission
        event.preventDefault();

        // Get the form element
        const form = $(event.target);

        // Get the URL action of the form
        let url = form.attr('action');

        // Remove trailing question mark if present
        if (url.endsWith('?')) {
            url = url.slice(0, -1);
        }

        // Redirect the form to the constructed URL
        window.location.href = url;
    }

    // Remove loading effect from button if page was restored from the bfcache
    utilities.restoreButtonState();

    const galleries = document.getElementsByClassName('iac-review-images');
    const toolbarButtonParams = {
        show: 1,
        size: 'large'
    };
    const viewerParams = {
        title: false,
        movable: false,
        rotatable: false,
        scalable: false,
        toolbar: {
            zoomIn: toolbarButtonParams,
            zoomOut: toolbarButtonParams,
            reset: toolbarButtonParams,
            prev: toolbarButtonParams,
            play: toolbarButtonParams,
            next: toolbarButtonParams,
            oneToOne: {
                show: false
            }
        }
    };
    [].forEach.call(galleries, function(gallery) {
        return new Viewer(gallery, viewerParams);
    });
});
